import { gql } from '@apollo/client';

// Shared queries for Implementations UI (single-organization scope)

export const GET_ORGANIZATION_IMPLEMENTATIONS = gql`
  query GetOrganizationImplementations($organizationId: UUID!) {
    organization(organizationId: $organizationId) {
      implementations {
        id
        name
        creditFacilities {
          id
          name
        }
      }
    }
  }
`;

// Query for implementation details with all necessary fields
export const GET_ORGANIZATION_IMPLEMENTATIONS_DETAILS = gql`
  query GetOrganizationImplementationsDetails($organizationId: UUID!) {
    organization(organizationId: $organizationId) {
      implementations {
        id
        name
        slug
        ownerOrganization {
          id
          name
          slug
        }
        borrowerOrganization {
          id
          name
          slug
        }
        loanProducts {
          id
          name
          slug
        }
        creditFacilities(includeInactive: true) {
          id
          name
          slug
          isActive
          borrowerEntityName
          type
        }
      }
    }
  }
`;
